import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { LightReachDisclosureDto } from "../dto/light-reach.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * LightReach disclosures for a Battery-Only Proposal's credit application.
 * The submit attests the `{id, version}` of each one shown, so the list is
 * never served from cache: each opening reads the versions LightReach
 * publishes now, rather than offering a stale version for consent.
 */
export default function useBatteryLightReachApplicationDisclosures(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<LightReachDisclosureDto[]> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.lightReachApplicationDisclosures(
      proposalId ?? ``,
    ),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getLightReachApplicationDisclosures(
        proposalId,
      )
    },
    enabled: Boolean(proposalId) && enabled,
    staleTime: 0,
    cacheTime: 0,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
